import axiosNest from '../../api/axiosNest';

/**
 * Historia zmian zlecenia strona po stronie (prace 24.10.2026, G1/K2;
 * przełącznik `orderHistoryCollapsed`, S-24.10-02; API:
 * `apps/api/src/user-offers/order-history.ts`).
 */

/** Klucz przełącznika — jak w API. */
export const FEATURE_ORDER_HISTORY_COLLAPSED = 'orderHistoryCollapsed';

/** Rodzaje wpisów — wartości parametru `kind` (dane API). */
export type HistoryKind = 'all' | 'human' | 'system' | 'import';

export const HISTORY_KIND_LABELS: Record<HistoryKind, string> = {
  all: 'Wszystko',
  human: 'Decyzje ludzi',
  system: 'System',
  import: 'Import z TMS',
};

export const HISTORY_KINDS: readonly HistoryKind[] = ['all', 'human', 'system', 'import'];

/** Ile wpisów na stronie. */
export const HISTORY_PER_PAGE = 25;

export interface HistoryEntry {
  id: number;
  field: string;
  oldValue: string | null;
  newValue: string | null;
  reason: string | null;
  reasonCode?: string | null;
  source: string | null;
  changedAt: string;
  changedBy: { id: number; username: string } | null;
}

export interface HistorySummary {
  total: number;
  humanDecisions: number;
  last: { changedAt: string; field: string; source: string | null; author: string | null } | null;
}

export interface HistoryPage {
  data: HistoryEntry[];
  total: number;
  page: number;
  perPage: number;
  summary: HistorySummary;
  vehicleNumbers: Record<string, string>;
}

export async function fetchOrderHistory(
  id: number | string,
  params: { kind: HistoryKind; page: number; perPage?: number },
): Promise<HistoryPage> {
  const { data } = await axiosNest.get<HistoryPage>(`/user-offers/${id}/changes`, {
    params: { kind: params.kind, page: params.page, perPage: params.perPage ?? HISTORY_PER_PAGE },
  });
  return data;
}

/** Liczba stron (co najmniej jedna). */
export const pageCount = (total: number, perPage: number): number =>
  Math.max(1, Math.ceil(total / Math.max(1, perPage)));

/**
 * Rozwinięcie historii pamięta przeglądarka (jedno dla wszystkich zleceń).
 * Bez magazynu (tryb prywatny, zablokowane dane) — zwinięta, bez błędu.
 */
const OPEN_KEY = 'marathon.orderHistory.open';

export function readHistoryOpen(): boolean {
  try {
    return window.localStorage.getItem(OPEN_KEY) === '1';
  } catch {
    return false;
  }
}

export function writeHistoryOpen(open: boolean): void {
  try {
    window.localStorage.setItem(OPEN_KEY, open ? '1' : '0');
  } catch {
    // Bez magazynu wybór żyje do odświeżenia strony.
  }
}
